import { useTranslation } from 'react-i18next'
import { Icon, I } from '../components/ui/icons'

/** "No SKU · linked by Salla option 1849302731" */
export function OptionLinkHint({ variantId }: { variantId?: string | null }) {
  const { t } = useTranslation()
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--fg-subtle)', fontSize: 11.5, lineHeight: '15px', flexWrap: 'wrap' }}>
      <Icon size={12} color="var(--fg-subtle)">{I.link}</Icon>
      {t('pages.products.options.linkHint')}
      {variantId && <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--fg-muted)' }}>{variantId}</span>}
    </span>
  )
}
